import {useRootSelector} from 'store';
import {selectProjectById} from 'store/projects';

export function useProjectSelector(projectId: string) {
  return useRootSelector((state) => selectProjectById(state, projectId));
}
